import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { BusinessTypeSelect } from "./BusinessTypeSelect";
import { CurrencySelect } from "./CurrencySelect";

interface RegistrationFieldsProps {
  fullName: string;
  setFullName: (value: string) => void;
  companyName: string;
  setCompanyName: (value: string) => void;
  email: string;
  setEmail: (value: string) => void;
  password: string;
  setPassword: (value: string) => void;
  selectedBusinessType: string;
  setSelectedBusinessType: (value: string) => void;
  selectedCurrency: string;
  setSelectedCurrency: (value: string) => void;
  businessTypes: any[];
}

export const RegistrationFields = ({
  fullName,
  setFullName,
  companyName,
  setCompanyName,
  email,
  setEmail,
  password,
  setPassword,
  selectedBusinessType,
  setSelectedBusinessType,
  selectedCurrency,
  setSelectedCurrency,
  businessTypes,
}: RegistrationFieldsProps) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="fullName">Nom complet</Label>
        <Input
          id="fullName"
          type="text"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="companyName">Nom de l'entreprise</Label>
        <Input
          id="companyName"
          type="text"
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="password">Mot de passe</Label>
        <Input
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength={6}
        />
      </div>

      <BusinessTypeSelect
        businessTypes={businessTypes}
        selectedBusinessType={selectedBusinessType}
        onBusinessTypeChange={setSelectedBusinessType}
      />

      <CurrencySelect
        selectedCurrency={selectedCurrency}
        onCurrencyChange={setSelectedCurrency}
      />
    </>
  );
};